import { type Locale, enUS, es } from 'date-fns/locale';
import type { LocaleConfig } from '../config';
import { type AppLanguage, appLanguages, supportedAppLanguagesNames } from '../supported-app-languages-names';

export const dateFnsLocales: Record<AppLanguage, LocaleConfig<Locale>> = {
  [appLanguages.english]: {
    locale: enUS,
    name: supportedAppLanguagesNames[appLanguages.english].name,
  },
  [appLanguages.spanish]: {
    locale: es,
    name: supportedAppLanguagesNames[appLanguages.spanish].name,
  },
};
